var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 6C8.25 8.20914 10.0409 10 12.25 10V15.2169H9.25V17.2169H12.25V20H8.25V22H13.25H14.25V21V16.2169V9.46487C15.4456 8.77325 16.25 7.48056 16.25 6C16.25 3.79086 14.4591 2 12.25 2C10.0409 2 8.25 3.79086 8.25 6ZM12.25 8C13.3546 8 14.25 7.10457 14.25 6C14.25 4.89543 13.3546 4 12.25 4C11.1454 4 10.25 4.89543 10.25 6C10.25 7.10457 11.1454 8 12.25 8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyVertical);
export default __webpack_public_path__ + "static/media/key_vertical.4e7ac1147190824802c43a58cd01c7cf.svg";
export { ForwardRef as ReactComponent };